import React, { useEffect } from 'react';
import AOS from 'aos';
import '../styles/video.scss';
import YouTube from 'react-youtube';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import Particles from 'particlesjs';

import Facebook from '../assets/social/facebook.png';
import Twitter from '../assets/social/twitter.png';
import Instagram from '../assets/social/instagram.png';
import YoutubeIcon from '../assets/social/youtube.png';
import Slack from '../assets/social/slack.png';
import Reddit from '../assets/social/reddit.png';

//https://www.youtube.com/watch?v=QfozT_f6Uxo

function Video() {
  useEffect(() => {
    AOS.refreshHard();
    Particles.init({
      selector: '.background',
      color: ['#A9A9A9', '#072a33'],
      sizeVariations: 5,
      connectParticles: true,
    });
  });
  const opts = {
    width: '100%',
    height: '800',
    playerVars: {
      autoplay: 1,
      mute: 1,
      color: 'white',
      loop: 1,
      rel: 0,
    },
  };
  return (
    <div className="Video">
      <div className="socialmedia">
        <table>
          <tbody>
            <tr>
              <td
                onClick={() => {
                  ReactGA.pageview('SocialLinks -> Facebook');
                  ReactPixel.trackCustom('SocialLinks -> Facebook');
                  window.open('https://www.facebook.com/uQuest/', '');
                }}
              >
                <img
                  alt="Facebook icon"
                  className="socialmediaIcon"
                  src={Facebook}
                />
              </td>
            </tr>
            <tr>
              <td
                onClick={() => {
                  ReactGA.pageview('SocialLinks -> Twitter');
                  ReactPixel.trackCustom('SocialLinks -> Twitter');
                  window.open('https://twitter.com/uQuest_official', '');
                }}
              >
                <img
                  alt="Twitter icon"
                  className="socialmediaIcon"
                  src={Twitter}
                />
              </td>
            </tr>
            <tr>
              <td
                onClick={() => {
                  ReactGA.pageview('SocialLinks -> Instagram');
                  ReactPixel.trackCustom('SocialLinks -> Instagram');
                  window.open('https://www.instagram.com/uquest_official/', '');
                }}
              >
                <img
                  alt="Instagram icon"
                  className="socialmediaIcon"
                  src={Instagram}
                />
              </td>
            </tr>
            <tr>
              <td
                onClick={() => {
                  ReactGA.pageview('SocialLinks -> Youtube');
                  ReactPixel.trackCustom('SocialLinks -> Youtube');
                  window.open(
                    'https://www.youtube.com/channel/UCD9Ay5zSKh_3kAWIep56Lgw',
                    '',
                  );
                }}
              >
                <img
                  alt="Youtube icon"
                  className="socialmediaIcon"
                  src={YoutubeIcon}
                />
              </td>
            </tr>
            <tr>
              <td
                onClick={() => {
                  ReactGA.pageview('SocialLinks -> Reddit');
                  ReactPixel.trackCustom('SocialLinks -> Reddit');
                  window.open(
                    'https://www.reddit.com/user/uQuest_official/',
                    '',
                  );
                }}
              >
                <img
                  alt="Reddit icon"
                  className="socialmediaIcon"
                  src={Reddit}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <YouTube
        onReady={() => AOS.refreshHard()}
        videoId="QfozT_f6Uxo"
        opts={opts}
      />
    </div>
  );
}

export default Video;
